const activeLabelStyles = {
  transform: 'scale(0.90) translateY(-5px)'
}

export default activeLabelStyles
